import { render, staticRenderFns } from "./SettleMent.vue?vue&type=template&id=c2d5f83a&scoped=true&"
import script from "./SettleMent.vue?vue&type=script&lang=js&"
export * from "./SettleMent.vue?vue&type=script&lang=js&"
import style0 from "./SettleMent.vue?vue&type=style&index=0&id=c2d5f83a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d5f83a",
  null
  
)

export default component.exports